import { observer } from "mobx-react";
/**
 * Show a blocker from a given record in "Consent" table.
 */ const ConsentRecordBlocker = observer((param)=>{
    let { record, replayBlockerRecord, replayFinished } = param;
/* Silence is golden... Until you have PRO Version! */ });
export { ConsentRecordBlocker };
